import { AgentWorkspaceConstants } from "lookup/AgentWorkspaceConstants";
import { getLoggedInUser } from "services/AuthService";

const STORAGE_PREFIX = "agws_agent_next_call_group_filters";

function storageKey() {
  const userId = getLoggedInUser()?.uuid;
  if (!userId) {
    return null;
  }
  return `${STORAGE_PREFIX}:${userId}`;
}

/**
 * Restores sticky filter selections for the current browser session (per user).
 * Returns null when nothing is stored or the payload is invalid.
 */
export function loadStickyFilterSelections() {
  const key = storageKey();
  if (!key) {
    return null;
  }
  try {
    const raw = sessionStorage.getItem(key);
    if (!raw) {
      return null;
    }
    const parsed = JSON.parse(raw);
    if (!parsed || typeof parsed !== "object") {
      return null;
    }
    const restored = {};
    for (const id of AgentWorkspaceConstants.AGENT_NEXT_CALL_GROUP_FILTER_IDS) {
      const value = parsed[id];
      restored[id] = Array.isArray(value) ? value : [];
    }
    return restored;
  } catch {
    return null;
  }
}

/**
 * Persists filter selections for the browser session (per user).
 */
export function saveStickyFilterSelections(selections) {
  const key = storageKey();
  if (!key || !selections) {
    return;
  }
  const payload = {};
  for (const id of AgentWorkspaceConstants.AGENT_NEXT_CALL_GROUP_FILTER_IDS) {
    payload[id] = Array.isArray(selections[id]) ? selections[id] : [];
  }
  try {
    sessionStorage.setItem(key, JSON.stringify(payload));
  } catch {
    // Quota / private mode — sticky filters are best-effort.
  }
}

/**
 * Whether Go/Next criteria were established this browser session (any save, including empty
 * selections after Go). Null means the agent never ran Go/filter changes.
 */
export function hasStickyFilterSession() {
  return loadStickyFilterSelections() != null;
}
